import React from 'react'

import {useParams} from "react-router-dom";
import InactivityLogout from '../services/InactivityLogout';
import Header from '../components/Header'
import HomeSection from '../components/homeSection'



export default function Home() {

    const {email} = useParams();
       
    return (
        <>
                <InactivityLogout>
                <Header searchterm={email} />
                <HomeSection searchterm={email} />
                </InactivityLogout>
        </>
    );
}